import { Box, Grid, GridItem } from '@chakra-ui/react'
import { RadioButton, Tooltip } from '@sequencehq/core-components'
import {
  GreyGrey10,
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  Lato12Regular,
  Lato13Bold
} from '@sequencehq/design-tokens'
import { ReactNode } from 'react'

/**
 * For core-components later, if this indeed is a common design!
 * @param props
 * @returns
 */
export const RadioGroup = (props: {
  name: string
  'data-testid'?: string
  value: string
  options: Array<{
    label: ReactNode
    value: string
    labelAnnotation?: ReactNode
    description?: ReactNode
    disabled?: boolean
    disabledReason?: string
    additionalComponent?: React.ReactNode
  }>
  onChange: (value: string) => void
}) => {
  return (
    <Box
      borderRadius="6px"
      border={`1px solid ${GreyGrey30}`}
      width="100%"
      overflow="hidden"
    >
      {props.options.map(opt => (
        <Box
          _notLast={{
            borderBottom: `1px solid ${GreyGrey30}`
          }}
          width="100%"
          key={`${opt.value}`}
        >
          <Tooltip isDisabled={!opt.disabledReason} label={opt.disabledReason}>
            <Grid
              gridTemplateAreas={`
              "radio label labelAnnotation" 
              "radio description description"
              "radio additionalComponent additionalComponent"
            `}
              gridTemplateColumns={'22px 1fr auto'}
              gridTemplateRows={'auto auto auto'}
              data-testid={`${props['data-testid'] ?? props.name}.option.${opt.value}`}
              width="100%"
              padding="16px"
              onClick={() => !opt.disabled && props.onChange(opt.value)}
              cursor={opt.disabled ? 'default' : 'pointer'}
              userSelect="none"
              _hover={
                opt.disabled
                  ? {}
                  : {
                      backgroundColor: GreyGrey10
                    }
              }
              transition="background-color 0.2s ease-in-out"
              opacity={opt.disabled ? 0.5 : 1}
            >
              <GridItem gridArea="radio">
                <RadioButton
                  name={props.name}
                  isChecked={props.value === opt.value}
                  disabled={opt.disabled}
                />
              </GridItem>
              <GridItem
                gridArea="label"
                {...Lato13Bold}
                color={GreyGrey80}
                paddingBottom="4px"
              >
                {opt.label}
              </GridItem>
              <GridItem
                gridArea="labelAnnotation"
                {...Lato12Regular}
                color={GreyGrey60}
              >
                {opt.labelAnnotation}
              </GridItem>
              <GridItem
                gridArea="description"
                {...Lato12Regular}
                color={GreyGrey60}
              >
                {opt.description}
              </GridItem>
              <GridItem gridArea="additionalComponent">
                {opt.additionalComponent}
              </GridItem>
            </Grid>
          </Tooltip>
        </Box>
      ))}
    </Box>
  )
}
